export default "__VITE_ASSET__BzrjaMIi__"